/**
 * Best-effort LAN IP via WebRTC. Returns null if blocked / unavailable.
 */
export function detectLocalIp(timeoutMs = 1500) {
  return new Promise((resolve) => {
    let done = false;
    const finish = (value) => {
      if (done) return;
      done = true;
      try {
        pc?.close?.();
      } catch (_e) {
        // ignore
      }
      resolve(value || null);
    };

    const timer = setTimeout(() => finish(null), timeoutMs);
    let pc;
    try {
      const RTCPeerConnection =
        window.RTCPeerConnection ||
        window.webkitRTCPeerConnection ||
        window.mozRTCPeerConnection;
      if (!RTCPeerConnection) {
        clearTimeout(timer);
        finish(null);
        return;
      }
      pc = new RTCPeerConnection({ iceServers: [] });
      pc.createDataChannel("");
      pc.onicecandidate = (event) => {
        if (!event?.candidate) return;
        const cand = event.candidate.candidate || "";
        const match = cand.match(
          /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9:]{3,})/i
        );
        if (!match) return;
        const ip = match[1];
        if (
          ip.startsWith("10.") ||
          ip.startsWith("192.168.") ||
          /^172\.(1[6-9]|2\d|3[0-1])\./.test(ip) ||
          ip.includes(":")
        ) {
          clearTimeout(timer);
          finish(ip);
        }
      };
      pc.createOffer()
        .then((offer) => pc.setLocalDescription(offer))
        .catch(() => {
          clearTimeout(timer);
          finish(null);
        });
    } catch (_e) {
      clearTimeout(timer);
      finish(null);
    }
  });
}
